import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import PageBase from '../components/PageBase';
import EndUserKeyForm from '../components/EndUserKeyForm';
import { uuidv4 } from '../utils/helpers';
import * as endUserActions from '../redux/modules/endUsers';
import * as packetboxActions from '../redux/modules/packetboxes';
import * as endUserKeyActions from '../redux/modules/endUserKeys';
import i18n from '../translations/i18n';

/*
PropTypes / DefaultProps
 */
const propTypes = {
  fetchEndUsers: PropTypes.func,
  fetchPacketboxes: PropTypes.func,
  createEndUserKey: PropTypes.func,
  endUsers: PropTypes.any,
  packetboxes: PropTypes.any,
  t: PropTypes.func,
};

const defaultProps = {};

class EndUserKeyCreate extends React.Component {
  /*
    Lifecycle methods
   */
  componentWillMount() {
    this.props.fetchEndUsers();
    this.props.fetchPacketboxes();
  }

  createUserKey = (values) => {
    this.props.createEndUserKey({
      action: 'ALL',
      consumer_id: values.consumer_id,
      paketbox___id: values.paketbox_id,
      guid: uuidv4(),
      max_lock: null,
      max_unlock: null,
      valid_from: new Date().toISOString(),
      valid_to: null,
    });
  };

  render() {
    let endUsers = [];
    let packetboxes = [];
    if (this.props.endUsers) {
      endUsers = Object.values(this.props.endUsers);
    }

    if (this.props.packetboxes) {
      packetboxes = Object.values(this.props.packetboxes);
    }

    return (
      <PageBase title={this.props.t('create_new_user_key')}>
        <EndUserKeyForm
          onSubmit={this.createUserKey}
          isModify={false}
          endUsers={endUsers}
          packetboxes={packetboxes}
        />
      </PageBase>
    );
  }
}

EndUserKeyCreate.defaultProps = defaultProps;
EndUserKeyCreate.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    packetboxes: state.packetboxes.entities,
    endUsers: state.endUsers.entities,
  };
}

const actions = Object.assign({}, endUserActions, packetboxActions, endUserKeyActions);

const extended = translate(['translations'], { i18n })(EndUserKeyCreate);
export default connect(mapStateToProps, actions)(extended);



// WEBPACK FOOTER //
// ./src/containers/EndUserKeyCreate.js